export const environment = {
  production: true,
  apiUrl: 'https://api.dicom-interactive.com',
  api: 'https://api.dicom-interactive.com',
  recaptcha: '6LcKMWEoAAAAAHcJbY4HnowDQ5A6ADzXkipfh9ZP',
  apiStrapi: 'https://cms.dicom-interactive.com/api',
  imgEndPoint: 'https://cms.dicom-interactive.com',
  strapiToken: 'f8aefe1a6b672139fb7a16fa66e05515abf2d3599dc19d97e8ac8cd5a27b51aa32cf129cd56d77b1ef044dfb4c0b8aea3cfca624557b29f6271a296266a5df71acfa93e5c03c857fa754d73752f054a6db2fc51c15a9069d3799667bc23cb8a10c514233798e676d6b2c429f7939e3182aefef21ef8d0776b48bc22e03d29a34',
};
